import './App.css';
import { Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import CashierDashboard from './pages/CashierDashboard';
import AdminDashboard from './pages/AdminDashboard';
import { ToastContainer, Zoom } from 'react-toastify';
import LoginStaff from './pages/LoginStaff';
import Layout from './components/layout/Auth/Layout';
import RequireAuth from './components/layout/Auth/RequireAuth';
import PersistLogin from './components/layout/Auth/PersistLogin';
import Unauthorized from './pages/Unauthorized';
import NotFound from './pages/NotFound';
import DirectRoute from './pages/DirectRoute';
import { ROLES } from './constant/constant';
import { API_BASE_URL } from './utils/env';

function App() {
  // const api = API_BASE_URL;
  // console.log("API: ", api)
  return (
    <div className="min-h-screen">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        transition={Zoom}
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
          <Route element={<PersistLogin />}>

            <Route element={<DirectRoute />}>
              <Route index path="login" element={<Login />} />
              <Route path="login-staff" element={<LoginStaff />} />
            </Route>

            {/* USER */}
            <Route element={<RequireAuth allowedRoles={[ ROLES.USER ]} />}>
              <Route path="/" element={<Home />} />
            </Route>

            {/* <Route element={ <RequireAuth allowedRoles={[ROLES.USER]}>
                    <MaintenanceGuard>
                      <Outlet />
                    </MaintenanceGuard>
                  </RequireAuth>
                }
            >
              <Route path="/" element={<Home />} />
            </Route> */}

            {/* CASHIER */}
            <Route element={<RequireAuth allowedRoles={[ ROLES.CASHIER ]} />}>
              <Route path="cashier-dashboard" element={<CashierDashboard />} />
            </Route>

            {/* ADMIN */}
            <Route element={<RequireAuth allowedRoles={[ ROLES.ADMIN, ROLES.ADMINISTRATOR, ROLES.SUPER_ADMIN, ROLES.DATA_ADMIN ]} />}>
              <Route path="admin-dashboard" element={<AdminDashboard />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;